import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';
import { V2DualPillComponent } from '../dual-pill/v2-dual-pill.component';

@Component({
  selector: 'coin-update-notifier',
  imports: [TranslateModule, V2DualPillComponent, MatTooltip],
  templateUrl: './update-notifier.component.html',
  styleUrl: './update-notifier.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateNotifierComponent {}
